import GlobalStyles from '@mui/material/GlobalStyles';
import { Theme } from '@mui/material';
import { useCallback } from 'react';

export const RootGlobalStyles = () => {
	return (
		<GlobalStyles
			styles={useCallback(
				(theme: Theme) => ({
					'@layer chat': {
						// :host sets the em base for the entire shadow DOM widget.
						// Explicit font-size overrides the all:initial shorthand for this property.
						':host': {
							all: 'initial' as const,
							fontSize: '11px',
							'@media (min-resolution: 1.25dppx)': {
								fontSize: 'calc(11px * 80 / 100)',
							},
							'@media (max-width: 576px)': {
								fontSize: '0.9em',
								'@media (min-resolution: 1.25dppx)': {
									fontSize: 'calc(0.9em * 80 / 100)',
								},
							},
						},
						'ul, p': {
							margin: 0,
							padding: 0,
						},
						'.icon': {
							stroke: 'var(--icon_color)',
							'&.icon--disabled': {
								opacity: 0.7,
								cursor: 'not-allowed',
							},
						},
						button: {
							margin: 0,
							padding: 0,
							fontSize: '1em',
							outline: 'none',
							cursor: 'pointer',
							backgroundColor: 'transparent',
							border: 0,
						},
					},
				}),
				[],
			)}
		/>
	);
};
